/* version b9cda20 */

(function () {
  let productData = null;

  let addToCartOriginalLabel = 'Add to Cart';

  if (window.variantStrings && window.variantStrings.addToCart) {
    addToCartOriginalLabel = window.variantStrings.addToCart;
  }

  function setAddToCartLabel(preorder_flag) {
    const add_to_cart = document.getElementsByName('add')[0];
    if (add_to_cart === undefined) return;

    const preorderLabel = document.getElementById('hypehound-pre-orders').dataset.addToCartButtonLabel;

    const addToCartButtonLabel = preorder_flag ? preorderLabel : addToCartOriginalLabel;

    if (window.variantStrings && window.variantStrings.addToCart) {
      window.variantStrings.addToCart = addToCartButtonLabel;
    }

    Array.from(add_to_cart.children).every((element) => { 
      // only change the first span element, if there. ignore rest.
      if (element.tagName === 'SPAN') {
        element.textContent = addToCartButtonLabel;
        return false;
      }
      return true;
    });
  }

  function formatReleaseDate() {
    const dateSpan = document.getElementById('hypehound-release-date');

    const localizedDays = dateSpan.dataset.daysTranslation;

    if (dateSpan.textContent.trim().startsWith('P')) {
      dateSpan.textContent = `${convertFromIso8601Duration(dateSpan.textContent)} ${localizedDays}`;
    }
  }

  function convertFromIso8601Duration(duration) {
    const days = duration.match(/(\d+)D/);
    if (!days) return 0;
    
    return parseInt(days[1]);
  }

  function loadProductData() {
    const product = JSON.parse(document.getElementById('hypehound-pre-orders').dataset.product);

    productData = product;
  }

  function variantSellingPlanId(variantId) {
    const currentVariant = productData.variants.find((variant) => {
      return variant.id === parseInt(variantId);
    });

    if (
      currentVariant === undefined ||
      currentVariant.selling_plan_allocations === undefined ||
      currentVariant.selling_plan_allocations.length === 0
    ) return null;

    const downpaySellingPlanGroups = productData.selling_plan_groups.filter((sellingPlanGroup) => {
      return sellingPlanGroup.app_id === 'downpay';
    });

    if (downpaySellingPlanGroups.length === 0) return null;

    const downpayPlanId = currentVariant.selling_plan_allocations.find((allocation) => {
      // TODO: there may be a nasty bug here: why are we looking only at the first downpay group? What if variant plan is on a different purchase option?
      return allocation.selling_plan_group_id === downpaySellingPlanGroups[0].id;
    }).selling_plan_id;

    return downpayPlanId;
  }

  function insertSellingPlanFormInputs(sellingPlanId) {
    //it's possible there are multiple add to cart forms on the page.
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');

    productForms.forEach((form) => { 
      create({
        tag: 'input',
        appendTo: form,
        attributes: {
          id: 'selected-purchase-option',
          type: 'hidden',
          name: 'selling_plan',
          value: sellingPlanId
        }
      })
    });
  }

  function removeSellingPlanFormInputs() {
    const sellingPlanInputs = document.querySelectorAll('[name="selling_plan"]')

    sellingPlanInputs.forEach((input) => {
      if (input !== null) {
        input.remove();
      }
    })
  }

  function updateSellingPlanFormInput(sellingPlanId) {
    if (sellingPlanId !== undefined) {
      removeSellingPlanFormInputs();
      insertSellingPlanFormInputs(sellingPlanId)
    }
  }

  function getInitialSellingPlanId() {
    const selectedVariantId = document.getElementById('hypehound-pre-orders').dataset.selectedVariantId;

    return variantSellingPlanId(selectedVariantId);
  }

  function togglePurchaseOptionBoxHidden(hide) {
    const purchaseOptionsBox = document.getElementById('downpay-product-wrapper');

    purchaseOptionsBox.hidden = hide;
  }

  function togglePurchaseOptionDescriptionHidden(hide) {
    const infoWrapper = document.getElementById('purchase-option-info-wrapper');
    infoWrapper.hidden = hide;
  }

  function updatePurchaseOptionDepositLabel(sellingPlanId) {
    const labelText = document.getElementById('hypehound-pre-orders').dataset[`plan${sellingPlanId}Label`];;

    const depositLabel = document.getElementById('purchase-option-label');
    depositLabel.textContent = labelText;
  }

  function updatePage(sellingPlanId) {
    if (sellingPlanId === null) {
      removeSellingPlanFormInputs();
      // TODO: would it be better here for UX to merely disable the deposit option and just leave the 'Pay in Full'?
      togglePurchaseOptionBoxHidden(true);
      setAddToCartLabel(false);
    } else {
      updatePurchaseOptionDepositLabel(sellingPlanId);
      togglePurchaseOptionBoxHidden(false);
      updateSellingPlanFormInput(sellingPlanId);
      setAddToCartLabel(true);
    }
  }

  function listenToPurchaseOptionChange() {
    const purchaseOptions = document.querySelectorAll('input[name="purchase_option"]');

    purchaseOptions.forEach((option) => {
      option.addEventListener('change', (event) => {
        if (event.target.id === 'purchase-option-full') {
          removeSellingPlanFormInputs();
          togglePurchaseOptionDescriptionHidden(true);
        } else {
          const sellingPlanId = event.target.dataset.sellingPlanId;
          updateSellingPlanFormInput(sellingPlanId);
          togglePurchaseOptionDescriptionHidden(false);
        }
      });
    });
  }

  function listenToFormChange() {
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');

    productForms.forEach((form) => {
      form.addEventListener('change', (event) => {
        if (event.target.tagName === 'INPUT' && event.target.name === 'id') {
          const variantId = event.target.value;
          const sellingPlanId = variantSellingPlanId(variantId);

          updatePage(sellingPlanId)
        }
      });
    });
  }

  function listenToThemeEditorEvents() {
    /**
     * For the AddToCart button, we need to handle changing the setting via JS
     * This is because the button is not part of our theme block, so we cannot
     * rely on the theme editor to update the button for us, unlike our other settings.
     */
    document.addEventListener('shopify:section:load', function(event) {
      setAddToCartLabel(true);
    });

    document.addEventListener('shopify:section:unload', function(event) {
      setAddToCartLabel(true); 
    });
  }

  // we use this check to see if we're running in the WYSIWYG Shopify theme editor
  if (Shopify.designMode) {
    listenToThemeEditorEvents();
  }

  // we use this check to see if we're running in theme preview mode
  if (Shopify.inspectMode) {
    //console.log(Shopify);
  }

  // utility function that simplifies creation of new html node
  function create({
    tag,
    appendTo,
    children = [],
    attributes = {},
    events = {},
  }) {
    const element = document.createElement(tag);

    Object.entries(attributes).forEach(([key, value]) => {
      element[key] = value;
    });

    Object.entries(events).forEach(([key, value]) => {
      element.addEventListener(key, value);
    });

    if (appendTo) {
      appendTo.appendChild(element);
    }

    children.forEach((child) => element.appendChild(child));

    return element;
  }

  function init() {
    if (document.getElementById('hypehound-pre-orders') !== null) {
      loadProductData();

      const initialSellingPlanId = getInitialSellingPlanId()
      insertSellingPlanFormInputs(initialSellingPlanId);
      updatePage(initialSellingPlanId);

      formatReleaseDate();

      listenToPurchaseOptionChange();
      listenToFormChange();
    }
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    window.addEventListener('DOMContentLoaded', function () {
      init();
    });
  }

})();